<template>
  <div class="main-navbar-button-root">
    <router-link v-if="route === '/dashboard'" :to="route" exact-active-class="active">
      <div class="position-relative">
        <notification-badge v-if="badge === true"></notification-badge>
        <icon :name="icon"></icon>
        <p class="d-block d-md-none d-lg-block">
            {{ title }}
        </p>
      </div>
    </router-link>
    <router-link v-else :to="route" active-class="active">
      <div class="position-relative">
        <notification-badge v-if="badge === true"></notification-badge>
        <icon :name="icon"></icon>
        <p class="d-block d-md-none d-lg-block">
            {{ title }}
        </p>
      </div>
    </router-link>
  </div>
</template>

<script>
import Icon from '@/components/Icon'
import NotificationBadge from '@/components/Notification-Badge'
export default {
  name: 'main-navbar-button',
  props: ['title', 'route', 'icon', 'badge'],
  components: {
    Icon,
    NotificationBadge
  }
}
</script>

<style scoped>
  a div {
      padding: 12px;
  }
  a div:hover,
  a.active div {
      background: #35383C;
  }
  div a {
    text-decoration: none;
    color: #bdc7d4;
  }
  img {
    height: 79px;
    width: auto;
    max-width: 100%;
    padding-bottom: 2px;
    display: block;
    margin: auto;
  }
  p {
    font-size: 10px;
    text-transform: uppercase;
    margin-bottom: 0;
    padding-top: 5px;
  }
</style>
